import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    holiday: []
}

const holidaySlice = createSlice({
    name: 'holiday',
    initialState,
    reducers: {
        addHoliday: (state, action)=>{
            state.holiday = action.payload
        }
    }
})

export const handleHoliday= (state)=>{
    return dispatch => {
        dispatch(holidaySlice.actions.addHoliday(state))
    }
}

export default holidaySlice.reducer